/**
 * 發願樹 Mock 資料
 * 未來切換到真實 API 時，只需修改 wishTreeService.js 中的 USE_MOCK 設定
 */

import { RINGS_BY_IMAGE_ID, TREE_SLOTS } from '../constants';

export const mockWishTreeData = {
  // 已掛上樹的發願卡列表（對齊 slot 固定點位，依陣列順序佔用點位；文案由 content_id 對應）
  wishList: {
    items: [],
    result_code: 200,
    message: 'Success',
  },
};

// 依 image_id 對應層級（RINGS_BY_IMAGE_ID）的實際點位數量出卡，確保各顏色筆數
// 不超過該顏色可掛的圈層容量，掛滿樹時分色排列不會溢出、撞點位。
const capacityByImageId = Object.entries(RINGS_BY_IMAGE_ID).reduce((acc, [imageId, rings]) => {
  acc[imageId] = TREE_SLOTS.filter((s) => rings.includes(s.ring)).length;
  return acc;
}, {});

let wishId = 1;
Object.entries(capacityByImageId).forEach(([imageId, capacity]) => {
  for (let n = 0; n < capacity; n += 1) {
    mockWishTreeData.wishList.items.push({
      wish_id: wishId,
      image_id: Number(imageId),
      content_id: (wishId % 6) + 1,
    });
    wishId += 1;
  }
});

export default mockWishTreeData;
